import React from 'react';

function RedditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M7 0a7 7 0 100 14A7 7 0 007 0zm2.922 2.767a.73.73 0 01.73.729.73.73 0 01-1.457.033l-1.515-.32-.467 2.186c1.064.041 2.03.369 2.726.868a.981.981 0 01.704-.286c.565 0 1.024.458 1.024 1.023 0 .418-.254.778-.59.941.017.1.025.202.025.304 0 1.571-1.826 2.84-4.086 2.84-2.26 0-4.085-1.269-4.085-2.84 0-.107.008-.214.025-.312a1.024 1.024 0 01.417-1.957c.27 0 .524.115.704.287.704-.515 1.679-.835 2.767-.868l.516-2.44a.2.2 0 01.082-.114.204.204 0 01.139-.025l1.695.36c.117-.25.37-.41.646-.409zM4.667 7.73A.73.73 0 015.396 7a.73.73 0 11-.729.73zM8.604 7a.73.73 0 10.73.729.73.73 0 00-.73-.729zM5.281 9.382a.19.19 0 01.135-.054v-.001c.05 0 .1.02.135.055.31.312.982.426 1.465.426.483 0 1.147-.115 1.466-.426a.193.193 0 01.27 0 .21.21 0 01-.017.27c-.499.5-1.449.533-1.727.533s-1.236-.041-1.727-.533a.192.192 0 010-.27z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default RedditIcon;
